

import Accounts from "./Accounts";


class Network extends Accounts{
    constructor(params) {
        super(params);
    
    this.accountLabel = "Network";
    this.accountType = "Network";
    this.account = "Network";
    this.Dashboard = [];
    this.isParent = true;
    this.networkConnections = {};
    this.configuration = {};
    this.access = [];
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
   
    setDomain(val){
       this.generic.subTitle = val;
        this.domain = val;
      if (val && val != ''){
      var pts = val.split(".");
          pts.pop();
      this.generic.url = "https://" + pts.pop() + ".simpliad.com";
      }
    }

    setDefaultSettings(json){
        this.defaultSettings = json;
    }
    setDocumentId(val){
        this.platformId = val;
        this.documentId = val;
        this.generic.id = val;
        this.id = val;
    }
    setPaymentScheme(val){
        this.paymentScheme = val;
        if (val == "simpliad-fpo"){
            this.access.push("network-default");
            this.isNetworkDefault = true;
        }
    }
    setAccesses(arr){
        this.access = arr.map((a)=>{return a.nickname.toLowerCase();});
        if (this.access.indexOf("network-default") > -1){this.isNetworkDefault = true;}
    }

        

    setConfiguration(json){
        this.networkConnections = (json.connections) ? json.connections : this.networkConnections;
        this.configuration = (json.settings) ? json.settings : this.configuration;
    }
}

export default Network;
  